import {useEffect, useState} from 'react';
import {Route, Switch, useRouteMatch} from 'react-router-dom';
import {useAppDispatch} from '../../store/hooks';
import {setTitle} from '../../store/header/header.slice';
import Container from '../../components/common/layout/Container';
import Information from './Information';
import UnsortableList from '../common/UnsortableList';
import useFetch from '../../hooks/useFetch';
import Error from '../common/Error';
import Tabs from '../common/Tabs';
import {MatchParams} from '../../constants/types';
import permissionsInfo from '../../constants/permissionsInfo';
import EnsurePermission from '../common/EnsurePermission';
import Spinner from '../common/Spinner';
import {DEFAULT_ERROR} from '../../api/constants';

const getTabs = (path: string) => ([
  {
    name: 'Information',
    link: path,
    permissions: null
  },
  {
    name: 'Groups',
    link: `${path}/groups`,
    permissions: permissionsInfo.tenants.list.groups
  },
  {
    name: 'Users',
    link: `${path}/users`,
    permissions: permissionsInfo.tenants.list.users
  }
]);

const EditTenant = () => {
  const dispatch = useAppDispatch();
  const {url, params, path}: MatchParams = useRouteMatch();
  const {id} = params || {};
  const [tenantName, setTenantName] = useState('');

  const [data, isLoading, error] = useFetch(`/tenants/${id}`);

  useEffect(() => {
    dispatch(setTitle(''));
  }, []);

  useEffect(() => {
    if (data) setTenantName(data?.name);
  }, [data]);

  if (error) {
    return <Error message={error?.message || DEFAULT_ERROR} />;
  }

  return (
    <Container header="System Configuration - Tenants">
      {!isLoading ? (
        <>
          <h2 className="subheader">Edit Tenant - {tenantName}</h2>
          <Tabs tabs={getTabs(url)} />

          <Switch>
            <Route exact path={url}>
              <Information
                id={id}
                name={tenantName}
                setTenantName={setTenantName}
              />
            </Route>

            <Route exact path={`${url}/groups`}>
              <EnsurePermission
                elementPermissions={permissionsInfo.tenants.list.groups}
                showError={true}>
                <UnsortableList
                  entityKey={`${path}/groups`}
                  id={id}
                  name={tenantName} />
              </EnsurePermission>
            </Route>

            <Route exact path={`${url}/users`}>
              <EnsurePermission
                elementPermissions={permissionsInfo.tenants.list.groups}
                showError={true}>
                <UnsortableList
                  entityKey={`${path}/users`}
                  id={id}
                  name={tenantName}
                />
              </EnsurePermission>
            </Route>
          </Switch>
        </>) : <Spinner loadingText="Getting tenant info" />}
    </Container>
  );
};

export default EditTenant;
